export class DataServiceRequestError extends Error {
	response: Response | undefined;
	constructor(message?: string, response?: Response) {
		super(message);
		this.response = response;
		Object.setPrototypeOf(this, new.target.prototype);
	}
}
